// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__H-lUH","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__Li8r-"};